<template>
  <el-dialog :title="title" :visible.sync="dialogDetail" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" height="500px" center border :key="tableKey">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="date" label="日期" align="center" :formatter="dateFormat" width="120"></el-table-column>
        <el-table-column prop="flowItemName" label="现金流量项目" align="center" width="210" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createSubcompanyName" label="公司名称" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDepartmentName" label="部门" align="center" width="150"></el-table-column>
        <el-table-column prop="income" label="收入(元)" align="center" ></el-table-column>
        <el-table-column prop="expenditure" label="支出(元)" align="center" ></el-table-column>
        <el-table-column prop="paymentMethod" label="付款方式" align="center" ></el-table-column>
        <el-table-column prop="supplierName" label="客户/供应商" align="center" width="180" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="remark" label="摘要" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="导入时间" :formatter="dateTimeFormat" width="180"></el-table-column>
        <el-table-column prop="createUser" label="导入人" align="center" width="120" show-overflow-tooltip></el-table-column>
      </el-table>
      <!-- 分页 -->
      <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[50,100,200,500]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryDetails } from '@/api/common-signature'
import { dateTimeFormat, emptyFn, dateFormat } from '@/utils/util'
export default {
  name: 'bumenDetails',
  components: {},
  data () {
    return {
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      tableDataList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      tableHeight: 500,
      tableKey: 0
    }
  },
  props: {
    title: {
      type: String
    },
    dialogDetail: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  watch: {
    tableDataList: {
      handler (newVal) {
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
  },
  created () {
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  methods: {
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 400

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = Math.min(800, 400 + (rowCount - 10) * 40) // 每行约40px
      }

      this.tableHeight = baseHeight
    },
    detailList () {
      this.$set(this.searchFrom, 'department', this.rowData.department)
      this.$set(this.searchFrom, 'flowItemName', this.rowData.cashflowItem)
      this.$set(this.searchFrom, 'tenantFaction', this.rowData.tenantFaction)
      this.$set(this.searchFrom, 'filterType', this.rowData.filterType)
      this.$set(this.searchFrom, 'month', this.rowData.month)
      queryDetails(this.searchFrom).then(res => {
        this.tableDataList = res.pageInfo.list
        this.total = res.pageInfo.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.detailList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.detailList(this.searchFrom)
    },
    closeadd () {
      this.$emit('update:dialogDetail', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
